<template>
  <el-container class="h-full overflow-hidden">
    <el-header>
      <!-- 引入顶栏 -->
      <Header/>
    </el-header>
    <el-container class="p-0 overflow-auto">
      <el-aside width="auto" style="box-shadow: 2px 0 6px rgb(0 21 41 / 35%)">
        <!-- 引入侧边栏 -->
        <Aside/>
      </el-aside>
      <!-- 引入标签栏 -->
      <Tag v-if="false" />
      <el-main>
        <router-view/>
        <!-- 路由视图 -->
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

import Aside from '../components/Aside.vue'
import Header from '../components/Header.vue'
import Tag from '../components/Tag.vue'
import { mapGetters } from 'vuex'
import { syncHistory } from '@/api/enterprise'

export default {
  name: 'Main',
  components: {
    Aside,
    Header,
    Tag
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['staff'])
  },
  mounted () {
    if (this.staff.syncStatus === 0) {
      this.openDialog()
    }
  },
  methods: {
    openDialog () {
      this.$confirm('系统检测到您有历史信息未同步，是否同步?', '提示', {
        confirmButtonText: '同步',
        cancelButtonText: '忽略',
        showClose: false,
        type: 'warning'
      }).then(() => {
        syncHistory({ syncStatus: 1 }).then(() => {
          this.$store.commit('staff/SET_STAFF', Object.assign({}, this.staff, { syncStatus: 1 }))
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$router.push('/info')
        })
      }).catch(() => {
        syncHistory({ syncStatus: 0 }).then(() => {
          this.$store.commit('staff/SET_STAFF', Object.assign({}, this.staff, { syncStatus: 1 }))
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$router.push('/info')
        })
      })
    }
  }
}
</script>

<style lang="less">
.el-header {
  background-color: #1D4B8C;
}

.el-main {
  padding-top: 0;
}
</style>
